const API_BASE = process.env.REACT_APP_API_URL || 'https://voidlink.shop/api';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Произошла ошибка');
  }

  return data;
}

export function login(username, password) {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
}

export function register(username, password) {
  return request('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
}

export function fetchMe() {
  const token = getToken();
  return request('/auth/me', {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function saveAuth(token, user) {
  localStorage.setItem('voidlink_token', token);
  localStorage.setItem('voidlink_user', JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem('voidlink_token');
  localStorage.removeItem('voidlink_user');
}

export function getToken() {
  return localStorage.getItem('voidlink_token');
}

export function getStoredUser() {
  const user = localStorage.getItem('voidlink_user');
  return user ? JSON.parse(user) : null;
}

export function linkTelegramId(telegramId) {
  const token = getToken();
  console.log('linkTelegramId called with:', telegramId);
  const body = JSON.stringify({ telegramId });
  console.log('Request body:', body);
  return request('/user/telegram', {
    method: 'POST',
    headers: { 
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: body,
  });
}
